module.exports = __webpack_public_path__ + "static/media/MIAB9510-180730-75_Small.c0980ead.jpg";